import React from "react";
import { useHistory } from "react-router-dom";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";

const Menu = () => {
  const history = useHistory();

  return (
    <nav id="menu" role="navigation" className="menu">
      <ul>
        <li
          className={`menu ${history.location.pathname === "https://www.cognitude.co.in/" ? "active" : ""}`}
        >
          <a
            href="https://www.cognitude.co.in/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Home
          </a>
        </li>
        <li
          className={`menu ${history.location.pathname === "https://www.cognitude.co.in/about-us" ? "active" : ""}`}
        >
          <a
            href="https://www.cognitude.co.in/about-us"
            target="_blank"
            rel="noopener noreferrer"
          >
            About Us
          </a>
        </li>
        <li
          className={`menu-hasdropdown ${
            history.location.pathname?.includes(
              "https://www.cognitude.co.in/ourservices",
            ) ||
            history.location.pathname === "/" ||
            history.location.pathname === "/vulnerability-scan" ||
            history.location.pathname === "/scan-result"
              ? "active"
              : ""
          }`}
        >
          <a>Our services</a>
          <ul className="menu-dropdown pl-0">
            <li className="mb-0">
              <a
                href="https://www.cognitude.co.in/ourservices/IT-security"
                target="_blank"
                rel="noopener noreferrer"
              >
                IT Solutions & Security Services
              </a>
            </li>
            <li className="mb-0">
              <a
                href="https://www.cognitude.co.in/ourservices/IT-consulting"
                target="_blank"
                rel="noopener noreferrer"
              >
                IT & GenAI Consulting
              </a>
            </li>
            <li className="mb-0">
              <a
                href="https://www.cognitude.co.in/ourservices/mobile-solution"
                target="_blank"
                rel="noopener noreferrer"
              >
                Mobile & POS Solutions
              </a>
            </li>
            <li className="mb-0">
              <a
                href="/"
                className={`${
                  history.location.pathname === "/" ||
                  history.location.pathname === "/vulnerability-scan" ||
                  history.location.pathname === "/scan-result"
                    ? "active"
                    : ""
                }`}
              >
                Vulnerability Scan
              </a>
            </li>
            {/* <li className="mb-0">
              <a
                href="https://engineeringmarg.cognitude.co.in"
                target="_blank"
                rel="noopener noreferrer"
              >
                Engineering College Predictor- Engineering Marg
              </a>
            </li> */}
            <li className="mb-0">
              <a
                href="https://v2text.cognitude.co.in/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Video to text Converter
              </a>
            </li>
          </ul>
        </li>
        <li
          className={`menu ${history.location.pathname === "https://www.cognitude.co.in/careers" ? "active" : ""}`}
        >
          <a
            href="https://www.cognitude.co.in/careers"
            target="_blank"
            rel="noopener noreferrer"
          >
            Careers
          </a>
        </li>
        <li
          className={`menu ${history.location.pathname === "https://www.cognitude.co.in/contact" ? "active" : ""}`}
        >
          <a
            href="https://www.cognitude.co.in/contact"
            target="_blank"
            rel="noopener noreferrer"
          >
            Contact Us
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default Menu;
